import axios from 'axios';

export const supplierContactApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/supplier-contact`,
    headers: {
        'Content-Type': 'application/json'
    }
})